export default __webpack_public_path__ + "static/media/950.5cc8ad7c.png";